import { render, staticRenderFns } from "./market-analysis.vue?vue&type=template&id=00064808&scoped=true&"
import script from "./market-analysis.vue?vue&type=script&lang=js&"
export * from "./market-analysis.vue?vue&type=script&lang=js&"
import style0 from "./market-analysis.vue?vue&type=style&index=0&id=00064808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00064808",
  null
  
)

export default component.exports